import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=7a6ecef3"
import script from "./AddBrand.vue?vue&type=script&lang=js"
export * from "./AddBrand.vue?vue&type=script&lang=js"
import style0 from "./AddBrand.vue?vue&type=style&index=0&id=7a6ecef3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports